import React from "react";
import { resolveMediaUrl } from "../../../helpers/resolveMediaUrl";

const DESCRIPTION_LIMIT = 120;

// Vem objeto pela API REST e string JSON pelo socket.
export function parseCtwaContext(value) {
	if (!value) return null;
	if (typeof value === "object") return value;
	try {
		const parsed = JSON.parse(value);
		return parsed && typeof parsed === "object" ? parsed : null;
	} catch (err) {
		return null;
	}
}

function safeHttpUrl(value) {
	const raw = String(value || "").trim();
	return /^https?:\/\//i.test(raw) ? raw : "";
}

function CtwaAdCard({ ctwaContext, imageUrl, darkMode }) {
	const ctx = parseCtwaContext(ctwaContext);
	if (!ctx) return null;

	const title = ctx.title || "Anúncio";
	const description = ctx.description || "";
	const shortDescription =
		description.length > DESCRIPTION_LIMIT
			? `${description.slice(0, DESCRIPTION_LIMIT)}…`
			: description;
	const image = resolveMediaUrl(imageUrl || ctx.thumbnailPath);
	const href = safeHttpUrl(ctx.sourceUrl);

	const content = (
		<div
			style={{
				width: "100%",
				maxWidth: 400,
				borderRadius: 10,
				overflow: "hidden",
				background: darkMode ? "#2e363a" : "#eeeeee",
				marginBottom: 6,
				cursor: href ? "pointer" : "default",
			}}
		>
			{image && (
				<img
					src={image}
					alt={title}
					style={{ width: "100%", display: "block", maxHeight: 260, objectFit: "cover" }}
				/>
			)}
			<div style={{ padding: "8px 10px", color: darkMode ? "#fff" : "#111" }}>
				<div style={{ fontSize: "0.7rem", opacity: 0.7, marginBottom: 2 }}>
					Veio de um anúncio{ctx.sourceType === "post" ? " (publicação)" : ""}
				</div>
				<div style={{ fontWeight: 600, fontSize: "0.9rem" }}>{title}</div>
				{shortDescription && (
					<div style={{ fontSize: "0.8rem", marginTop: 2, whiteSpace: "pre-wrap" }}>
						{shortDescription}
					</div>
				)}
			</div>
		</div>
	);

	if (!href) return content;

	return (
		<a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
			{content}
		</a>
	);
}

export default CtwaAdCard;
